<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-02-02 11:25:49
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2024-07-08 16:43:38
 * @FilePath: \报考系统\mapa-web\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <Header v-show="this.$route.meta.isShow ? false : true" />
    <div>{{ }}</div>
    <!-- <div style="min-height: 800px">
                                                                                                      <router-view />
                                                                                                    </div> -->
    <div>
      <router-view />
    </div>
    <Footer v-show="this.$route.meta.isShow ? false : true" />
  </div>
</template>

<script>
import Footer from './components/pubilc/footer/index'
import Header from './components/pubilc/header/index'
export default {
  name: 'App',
  data() {
    return {

    }
  },
  components: {
    Footer,
    Header
  },
  mounted() {

  },
}
</script>

<style>
#app {
  font-family: PingFangSC-Regular, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-form-item {
  width: 480px;
}


.vjs-duration {
  display: block !important;

  /* 更改背景颜色 */
}

.vjs-current-time {
  display: block !important;
}

.el-tree-node__content {
  /* width: 100%;
  overflow: hidden;
  border-bottom: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  font-size: 15px; */
  font-size: 12px;
}

/*  点击时的样式 */
.el-tree .el-tree-node:focus>.el-tree-node__content {
  background-color: #353938 !important;


}

/*  鼠标hover改变背景颜色 */
.el-tree .el-tree-node>.el-tree-node__content:hover {
  background-color: #353938 !important;


}

/*  颜色高亮 */
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #353938 !important;
  color: #54a2f5;

}
</style>



// WEBPACK FOOTER //
// src/App.vue